/** GraphQL client for clinical-service (Prontuário). Content is decrypted
 *  server-side ONLY for the professional of the attendance (care gate). */
const API_URL = process.env.REACT_APP_CLINICAL_SERVICE_BASE_URL || '';

export interface ClinicalRecordMeta {
    id: string;
    clientId: string;
    appointmentId: string | null;
    teamMemberId: string;
    serviceId: string | null;
    templateKey: string | null;
    status: 'DRAFT' | 'SIGNED';
    contentHash: string | null;
    createdOn: string | null;
    signedOn: string | null;
}

async function post(query: string, variables: Record<string, unknown>, token: string) {
    if (!API_URL) throw new Error('clinical service URL not configured');
    const r = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ query, variables }),
    });
    if (!r.ok) throw new Error(`clinical-service ${r.status}`);
    const json = await r.json();
    if (json.errors?.length) throw new Error(json.errors[0]?.message || 'clinical error');
    return json.data;
}

const META_FIELDS = 'id clientId appointmentId teamMemberId serviceId templateKey status contentHash createdOn signedOn';

export async function clinicalRecords(businessId: number, clientId: number, token: string): Promise<ClinicalRecordMeta[]> {
    const d = await post(`query($b: ID!, $c: ID!) { clinicalRecords(businessId: $b, clientId: $c) { ${META_FIELDS} } }`,
        { b: businessId, c: clientId }, token);
    return d.clinicalRecords ?? [];
}

export async function clinicalRecordContent(businessId: number, recordId: string, token: string):
        Promise<{ record: ClinicalRecordMeta; content: string }> {
    const d = await post(`query($b: ID!, $r: ID!) { clinicalRecordContent(businessId: $b, recordId: $r) { record { ${META_FIELDS} } content } }`,
        { b: businessId, r: recordId }, token);
    return d.clinicalRecordContent;
}

export async function clinicalRecordByAppointment(businessId: number, appointmentId: string,
        token: string): Promise<ClinicalRecordMeta | null> {
    const d = await post(`query($b: ID!, $a: ID!) { clinicalRecordByAppointment(businessId: $b, appointmentId: $a) { ${META_FIELDS} } }`,
        { b: businessId, a: appointmentId }, token);
    return d.clinicalRecordByAppointment ?? null;
}

export async function saveClinicalRecord(businessId: number, input: {
    id?: string | null; clientId?: number | null; appointmentId?: string | null;
    serviceId?: string | null; templateKey?: string | null; content: string;
}, token: string): Promise<ClinicalRecordMeta> {
    const d = await post(
        `mutation($b: ID!, $id: ID, $c: ID, $a: ID, $s: String, $t: String, $content: String!) {
            saveClinicalRecord(businessId: $b, id: $id, clientId: $c, appointmentId: $a,
                               serviceId: $s, templateKey: $t, content: $content) { ${META_FIELDS} }
        }`,
        { b: businessId, id: input.id ?? null, c: input.clientId ?? null, a: input.appointmentId ?? null,
          s: input.serviceId ?? null, t: input.templateKey ?? null, content: input.content }, token);
    return d.saveClinicalRecord;
}

export async function signClinicalRecord(businessId: number, recordId: string, token: string): Promise<ClinicalRecordMeta> {
    const d = await post(`mutation($b: ID!, $r: ID!) { signClinicalRecord(businessId: $b, recordId: $r) { ${META_FIELDS} } }`,
        { b: businessId, r: recordId }, token);
    return d.signClinicalRecord;
}
